<template>
	<div class="eia-nav-bar">
		<div class="eia-page-boundary-container">
			<quod-logo></quod-logo>
			<router-link to="/">
				<eia-logo></eia-logo>
			</router-link>

			<eia-button
				variation="success"
				:path="faqPath">
				Need Help?
			</eia-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'eia-nav-bar',
	computed: {
		faqPath() {
			return {
				path: '/faq',
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-nav-bar {
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: space-between;
	height: 128px;
	border-bottom: 1px solid $color-grey-medium;

	.eia-logo {
		width: 140px;
		background-position: 0% 50%;
	}
}
</style>
